import { ReactNode } from "react";

import { Box, Container, Grid } from "@mui/material";

type BodyLayerProps = {
	floatingContent?: ReactNode;
	fixedContent?: ReactNode;
	children: ReactNode;
};

export default function BodyLayer(props: Readonly<BodyLayerProps>) {
	return (
		<Container className="main-area" id="main-area" disableGutters maxWidth={"xl"}>
			<Grid container direction="column" alignItems="center">
				<Grid
					item
					className="min-h-[650px] !bg-layout border-layout rounded-bl-[20px] rounded-br-[20px] relative max-w-[1440px] w-[1440px]"
				>
					{props.floatingContent}
					<Grid container position="relative">
						{Boolean(props.fixedContent) && (
							<Grid item xs={2}>
								<Box className="w-[240px] h-[660px] fixed z-10">{props.fixedContent}</Box>
							</Grid>
						)}
						<Grid container item xs={props.fixedContent ? 10 : 12} className="p-[20px]">
							{props.children}
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Container>
	);
}
